import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-performance-indicator-arrow',
    templateUrl: './performance-indicator-arrow.component.html',
    styleUrls: ['./performance-indicator-arrow.component.scss'],
    standalone: false
})
export class PerformanceIndicatorArrowComponent implements OnInit {
  @Input()
  isBigIcon: boolean;

  @Input()
  isPositive?: boolean;

  @Input()
  isTheSame: boolean;

  swapColors = false;

  constructor(private readonly translateService: TranslateService, private readonly languageService: LanguageService) {}

  ngOnInit() {
    const currentLanguage = this.translateService.currentLang;
    if (this.languageService.getSwapColorsLanguageCodes().indexOf(currentLanguage) > -1) {
      this.swapColors = true;
    }
  }
}
